const SET_RESUME_DEPOSIT = "SET_RESUME_DEPOSIT";
const RESUME_DEPOSIT_NAMESPACE = "RESUME_DEPOSIT_NAMESPACE";

export { RESUME_DEPOSIT_NAMESPACE, SET_RESUME_DEPOSIT };
